import React from 'react';
class Ad extends React.Component {
    render() {
        return (
            <div className={`display-ad display_${this.props.nbr}`}>
                <div className={`${this.props.fitAdsToContent ? 'adunit-wrapper-fit_to_content ' : ''}adunit-wrapper d-flex flex-column align-items-center full-width-breakout`}>
                    <div className="adunit"
                        count={this.props.nbr}
                        data-aller-ad-placement={`responsive_${this.props.nbr}`}>
                    </div>
                </div>
            </div>
        );
    }
}
export default Ad;
